import { Component, OnInit } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'app-portal-redirect',
  templateUrl: './portal-redirect.component.html',
  styleUrls: ['./portal-redirect.component.css']
})
export class PortalRedirectComponent implements OnInit {
  private _currentFacility: FacilityObject;
  constructor(
    public facilityService: FacilityService,
    public commonUtil: CommonUtil,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _subscriptionService: SubscriptionService,
    private _loader: HaloLoaderService
  ) { }

  async ngOnInit() {
    try {     
      this._currentFacility = this.facilityService.selectedFacility();
      //initialize facility when not invoke inside halo app
      if(!this._currentFacility?.summary){
        this._loader.startProcess();
        await this.facilityService.get();
        this._loader.endProcess();
        this._currentFacility = this.facilityService.selectedFacility();
      } 
      this.commonUtil.redirectToAvailablePage();
      if(this._currentFacility?.summary && 
        this._currentFacility.summary.isProEnabled === 'true') {
        this.goToPurchasePage();
      }
    } catch (error) {
      console.error('API failed.');
    }
  }

  goToPurchasePage() { 
    if (this._currentFacility.summary.isSubscriptionBannerEnabled === 'true') {
      this.facilityService
        .setFacilityUserPreference('isSubscriptionBannerEnabled', false)
        .then()
        .finally(() => {
          this._subscriptionService.getToken();
        });
    } else {
      this._subscriptionService.getToken();
    }
  }
}
